import { HttpClient } from '@angular/common/http';
import { FilterOptions, GridData, HTTPResponseList, ListOptions } from '@ot/shared/model';
import { LocalDateTime, ZoneId } from 'js-joda';
import { map } from 'rxjs/operators';
import { Environment, EnvironmentConfigService, IftaServiceName } from '../environment';
import * as i0 from "@angular/core";
import * as i1 from "../../../../model/src/lib/environment.token";
import * as i2 from "@angular/common/http";
import * as i3 from "../environment/environment-config.service";
export class TaxAccountService {
    constructor(environment, http, environmentConfigService) {
        this.http = http;
        this.serviceUrl =
            environmentConfigService.getEnvironmentConfigs().apis.ifta.url +
                '/' +
                environment.serviceUrlList[IftaServiceName.TaxAccountService];
        this.serviceUrlVehicleTaxAccount =
            environmentConfigService.getEnvironmentConfigs().apis.ifta.url +
                '/' +
                environment.serviceUrlList[IftaServiceName.VehicleTaxAccountService];
    }
    // TODO: Move VehicleExtensionService to shared instead of having duplicated methods
    getTaxAccounts(options, businessAccountId) {
        const filterObject = {
            options,
            filter: {
                global: {
                    businessAccountIds: [{ value: businessAccountId }]
                }
            }
        };
        return this.http
            .post(`${this.serviceUrl}/tax_account/list`, filterObject)
            .pipe(map(response => ({
            items: response.taxAccounts,
            totalSize: +response.totalCount
        })));
    }
    // TODO: Move VehicleExtensionService to shared instead of having duplicated methods
    getUnassignedVehicleIds(businessAccountId) {
        return (this.http
            // Array of VehicleTaxAccount type here (in ifta lib)
            .get(`${this.serviceUrl}/unassigned/vehicle_tax_account/${businessAccountId}`)
            .pipe(map(response => response.vehicleTaxAccount), map(vehicleTaxAccount => vehicleTaxAccount.map(vehicle => vehicle.vehicleId.value))));
    }
    // TODO: Move VehicleExtensionService to shared instead of having duplicated methods
    getVehicleIdsForTaxAccount(businessAccountId, taxAccountId) {
        // TODO: use `const request: APIGetVehicleTaxAccountsRequest` typing
        const request = {
            businessAccountId: { value: businessAccountId },
            taxAccountId: { value: taxAccountId },
            startDate: '2018-01-01T00:00:00Z',
            endDate: LocalDateTime.now()
                .atZone(ZoneId.UTC)
                .toString(),
            includeIftaDisabledVehicles: true
        };
        // TODO: use `.post<APIGetVehicleTaxAccountsResponse>` typing
        return this.http
            .post(`${this.serviceUrlVehicleTaxAccount}/vehicle_tax_accounts`, request)
            .pipe(map(response => response.vehicleTaxAccount.map(vehicleTaxAccount => vehicleTaxAccount.vehicleId.value)));
    }
}
TaxAccountService.ngInjectableDef = i0.defineInjectable({ factory: function TaxAccountService_Factory() { return new TaxAccountService(i0.inject(i1.ENVIRONMENT), i0.inject(i2.HttpClient), i0.inject(i3.EnvironmentConfigService)); }, token: TaxAccountService, providedIn: "root" });
